import { render, staticRenderFns } from "./studentAnalysis.vue?vue&type=template&id=b1f4f390&scoped=true&"
import script from "./studentAnalysis.vue?vue&type=script&lang=js&"
export * from "./studentAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./studentAnalysis.vue?vue&type=style&index=0&id=b1f4f390&prod&scoped=true&lang=less&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f4f390",
  null
  
)

export default component.exports